import { Integer, Keyword } from "@siteimprove/alfa-css";
import { Parser } from "@siteimprove/alfa-parser";
import { Longhand } from "../longhand.js";
import { Resolver } from "../resolver.js";
const { either } = Parser;
const parse = either(Keyword.parse("auto"), Integer.parse);
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/z-index}
 * @internal
 */
export default Longhand.of(Keyword.of("auto"), parse, (value, style) => value.map((zIndex) => zIndex.resolve(Resolver.length(style))), { inherits: false });
//# sourceMappingURL=z-index.js.map